import Box from '@mui/material/Box';
import React from 'react';
import { useParams } from 'react-router';

import BottomNavigationBar from '../../components/Layouts/BottomNavigationBar/BottomNavigationBar';
import Footer from '../../components/Layouts/Footer/Footer';
import LayoutSingleColumn from '../../components/Layouts/LayoutSingleColumn';
import LayoutWrapperBottombar from '../../components/Layouts/LayoutWrapperBottombar/LayoutWrapperBottombar';
import LayoutWrapperFooter from '../../components/Layouts/LayoutWrapperFooter/LayoutWrapperFooter';
import LayoutWrapperMain from '../../components/Layouts/LayoutWrapperMain';
import LayoutWrapperTopbar from '../../components/Layouts/LayoutWrapperTopbar/LayoutWrapperTopbar';
import TopBar from '../../components/Layouts/TopBar/TopBar';
import AnimatedLogo from '../../components/Logo/VanSite/AnimatedLogo';
import Page from '../../components/Page/Page';

const formatTitle = (slug) => {
  let title = slug.split(/-|\//);
  return title.reduce((acc, word) => {
    return acc + ' ' + word.charAt(0).toLocaleUpperCase() + word.slice('1');
  }, '');
};

const getSlug = (params) => {
  return `${params.slug}${params.rest ? `/${params.rest}` : ''}`;
};

const StoryblokLoadingPage = () => {
  const params = useParams();
  const slug = getSlug(params);

  const title = formatTitle(slug);

  return (
    <Page title={title}>
      <LayoutSingleColumn>
        <LayoutWrapperTopbar>
          <TopBar currentPage="StoryblokPage" />
        </LayoutWrapperTopbar>
        <LayoutWrapperMain>
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              height: {
                xs: '100vh',
                sm: '100vh',
                md: 'calc(100vh - var(--topbarHeightDesktop))',
              },
            }}
          >
            <AnimatedLogo />
          </Box>
        </LayoutWrapperMain>
        <LayoutWrapperFooter>
          <Footer />
        </LayoutWrapperFooter>
        <LayoutWrapperBottombar>
          <BottomNavigationBar />
        </LayoutWrapperBottombar>
      </LayoutSingleColumn>
    </Page>
  );
};

export default StoryblokLoadingPage;
